import { Zone } from "./interface";
import { TerrorZone } from "./terrorZones";

export interface VouchRequest {
  readonly ladder: string;
  readonly zone: TerrorZone;
  readonly voucher?: string;
}

export const validateVouchRequest = (predicate: any): predicate is VouchRequest => {
  return predicate.zone 
      && typeof predicate.zone === 'string'
      && Object.values(TerrorZone).includes(predicate.zone);
}

export interface VouchResponse {
  candidates: Array<Zone>;
}

export interface GetHistoryResponse {
  readonly history: Array<Zone>;
  readonly nextIndex: string;
}

export interface OAuthPayload {
  readonly tokenType: string;
  readonly token: string;
}